import React from 'react';
import { X } from 'lucide-react';
import { PropertyCompsSection } from './PropertyCompsSection';

interface PropertyAnalysisModalProps {
  submission: any | null;
  isOpen: boolean;
  onClose: () => void;
}

export function PropertyAnalysisModal({ submission, isOpen, onClose }: PropertyAnalysisModalProps) {
  if (!isOpen || !submission) return null;

  const address = [
    submission.propertyStreet,
    submission.propertyCity,
    submission.propertyState,
  ].filter(Boolean).join(', ');

  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center bg-black/60 overflow-y-auto py-8 px-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-5xl flex flex-col">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200 sticky top-0 bg-white rounded-t-2xl z-10">
          <div>
            <h2 className="text-xl font-bold text-gray-900">Property Analysis</h2>
            {address && <p className="text-sm text-gray-500 mt-0.5">{address}</p>}
          </div>
          <button
            onClick={onClose}
            className="p-2 rounded-lg text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6">
          <PropertyCompsSection
            submissionId={submission.id}
            claimedArv={submission.arv}
          />
        </div>
      </div>
    </div>
  );
}
